import axios from 'axios';
import React, { useEffect, useRef, useState } from 'react'
import { Alert, Col, Container, Row } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import { toast } from "react-toastify";
import CustomInput from '../CustomInput/CustomInput';
import CustomBtn from '../CustomBtn/CustomBtn';
import "./CodeResultContainer.css"
function CodeResultContainer() {
  const [loading, setLoading] = useState(false);
  const { currentLocal } = useSelector((state) => state.currentLocal);
  const [msg, setMsg] = useState(null);
  const [product, setProduct] = useState(null);
  const [status, setStatus] = useState(null);
  const { code } = useParams(); // هنا هيجيب 123 من الرابط
  const navigate = useNavigate();
const hasRun = useRef(false);
    const handleVerify = async () => {
      if (hasRun.current) return;
  hasRun.current = true;

      if (!code) {
        toast.error(currentLocal.home.fillFieldCode, { position: "bottom-right", autoClose: 3000 });
        return;
      }

      setLoading(true);

      try {
        // call your API here
        const response = await axios.get(`https://api.smileheavenglow.com/api/products/${code}`, {
          headers: {
            "accept-language": currentLocal.language === "العربيه" ? "ar" : "en",

          }
        })
        console.log(response, "vnbnv");
        // if(response.data.message==="Product is original"||"المنتج اصلي"){
        //   setStatus(1);
        // }else if(response.statusText==="No Content"){
        //   setStatus(2);

        // }else if(response.statusText==="Accepted"){
        //             setStatus(3);

        // }
console.log(response.status);

        if(response.status===200){
            setStatus(1);
            setProduct(response.data.data)
        }else if(response.status===202){
 setStatus(3);
        }else if(response.status===204){
           setStatus(2);

        }

      } catch (error) {
        console.error(error);
        toast.error(currentLocal.home.serverError || "Server error", { position: "bottom-right" });
      } finally {
        setLoading(false);
      }
    };
  useEffect(() => {


    handleVerify()
  }, [])
  console.log(status);

  return (
    <div className='py-5 code_result_container'>
      <Container>
        <Row className='mx-2'>
          <Alert key={status == 1 ? 'success' : 'danger'} variant={status == 1 ? 'success' : 'danger'}>
            <p className='mb-0 fw-bold'>
              {status == 3 &&
                <>
                  {/* <p>{currentLocal.home.Invalidcode}</p> */}
                  <p>{currentLocal.home.InvalidcodeMsg}</p>
                </>
              }
              {status == 2 &&
                <>
                  {/* <p>{currentLocal.home.Thecodehasalreadybeenused}</p> */}
                  <p>{currentLocal.home.Warning}</p>
                </>
              }
              {status == 1 &&
                <>
                  {/* <p>{currentLocal.home.Theproductisoriginal}</p> */}
                  <p>{currentLocal.home.Congratulations}</p>
                </>
              }

            </p>
          </Alert>

        </Row>
        {product &&
          <Row className='mt-3'>
            <Col md={4}>
              <div className='text-center'>
                <img src={product?.images[0]?.image} alt='' className='w-75' />

              </div>
            </Col>
            <Col md={8}>
              <h3 className='mb-3'>{product?.title}</h3>
              <p><span className='fw-bold'>{currentLocal.home.description} : </span>{product?.description}</p>

              <p><span className='fw-bold'>{currentLocal.home.Howtouse} : </span>{product?.how_to_use}</p>

            </Col>
          </Row>
        }
  
    <div className='d-flex justify-content-center'>
          <div className='d-flex justify-content-center  return_btn'style={{
            width: "50%",
          }}>
            <CustomBtn text={currentLocal.home.goback} disabled={loading} clickingFunction={()=>navigate("/Product/Verify")}/>
          </div>
    </div>
      </Container>
    </div>
  )
}

export default CodeResultContainer